<glxy-page [pagePadding]="false" [mobileMaxWidth]="0">
  @if ((showToolbarOnMobile$ | async) || !isMobile) {
    <glxy-page-toolbar>
      <glxy-page-title>
        <span>{{ 'INBOX.HEADER.TITLE' | translate }}</span>
      </glxy-page-title>
      <glxy-page-actions>
        <button mat-stroked-button [matMenuTriggerFor]="inboxMenu">
          {{ 'INBOX.MORE' | translate }}
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #inboxMenu="matMenu">
          <button mat-menu-item routerLink="../crm/contact/list">
            <mat-icon>person</mat-icon>
            <span>{{ 'INBOX.CUSTOMERS' | translate }}</span>
          </button>
          <button mat-menu-item routerLink="../inbox/settings">
            <mat-icon>settings</mat-icon>
            <span>{{ 'INBOX.SETTINGS_LINK' | translate }}</span>
          </button>
        </mat-menu>
        <a
          mat-flat-button
          color="primary"
          [routerLink]="['new-message']"
          [queryParamsHandling]="'merge'"
          data-action="clicked-new-message_top-bar"
          class="new-message-button"
        >
          <mat-icon aria-hidden="false" aria-label="Send a new message">edit_square</mat-icon>
          <span class="label">{{ 'INBOX.NEW_MESSAGE.NEW_MESSAGE' | translate }}</span>
        </a>
      </glxy-page-actions>
    </glxy-page-toolbar>
  }
  <div class="inbox-container">
    <div class="inbox-panes">
      @if (!isMobile && (organizationHasConversations$ | async)) {
        <div class="inbox-left-pane">
          <inbox-pane></inbox-pane>
        </div>
      }
      <router-outlet></router-outlet>
    </div>
  </div>
</glxy-page>
